// Firebase configuration and initialization with Enhanced Security
    import { initializeApp } from 'firebase/app';
    import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
    import { getAuth, connectAuthEmulator } from 'firebase/auth';
    import { getStorage, connectStorageEmulator } from 'firebase/storage';

    // 🔒 SECURE: Firebase configuration from environment variables
    const firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBu_tJFkdoEKNZwV4XD0xjzWZaSOXIw1-U",
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "expert-guru-469c4.firebaseapp.com",
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "expert-guru-469c4",
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "expert-guru-469c4.firebasestorage.app",
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "269755252577",
      appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:269755252577:web:4587be25535af5c9130f20",
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-Z9TQ1H0F0G"
    };

    // 🔒 SECURE: Validate configuration
    const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
    const missingKeys = requiredKeys.filter(key => !firebaseConfig[key] || firebaseConfig[key] === 'your-api-key-here' || firebaseConfig[key] === 'undefined');

    if (missingKeys.length > 0) {
      console.error('🔒 SECURITY WARNING: Missing Firebase configuration keys:', missingKeys);
      // We do NOT throw here to allow the app to render the error UI
    }

    // 🔒 SECURE: Initialize Firebase with error handling
    let app;
    let db;
    let auth;
    let storage;

    try {
      console.log('🔒 Initializing Firebase...');
      app = initializeApp(firebaseConfig);
      db = getFirestore(app);
      auth = getAuth(app);
      storage = getStorage(app);

      // 🔒 SECURITY: Only connect to emulators in development with explicit flag
      if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
        try {
          connectFirestoreEmulator(db, 'localhost', 8080);
          connectAuthEmulator(auth, 'http://localhost:9099');
          connectStorageEmulator(storage, 'localhost', 9199);
          console.log('🔒 Connected to Firebase emulators (Development Mode)');
        } catch (error) {
          console.warn('🔒 Could not connect to Firebase emulators:', error.message);
        }
      }
      
      console.log('✅ Firebase initialized successfully');
    } catch (error) {
      console.error('🔒 CRITICAL ERROR: Firebase initialization failed:', error);
      // Do not re-throw, allow app to handle null services
    }

    // 🔒 SECURE: Export Firebase services
    export { db, auth, storage };
    export default app;

    // 🔒 SECURITY: Export configuration status for monitoring
    export const firebaseStatus = {
      isInitialized: !!app,
      hasValidConfig: missingKeys.length === 0,
      projectId: firebaseConfig.projectId,
      environment: import.meta.env.DEV ? 'development' : 'production',
      error: missingKeys.length > 0 ? 'Missing Configuration' : null
    };